import React from 'react';
import { useState } from 'react';
import ExperienceForm from './Partials/ExperienceForm';
import ExperienceLayout from './Partials/ExperienceLayout';
import { post } from '../../../api/node';
import { useTranslation } from 'react-i18next';
import { useSnack, useSearchParams } from '../../../hooks';
import { Spinner as Loader } from '@koob/margaret';
import { initialLocale } from '../../../utils';
import { saveExperienceCancelConditions } from 'api/node/experiences';
import { formatCancellationPoliciesToPayload } from 'components/Fields/CancelConditionField/utils';
import { omit } from 'lodash';

export default function ExperienceCreate() {
  const { t } = useTranslation('experiences');
  const { notify, notifyError } = useSnack();
  const [saveIsLoading, setSaveIsLoading] = useState(false);
  const [searchParams] = useSearchParams();

  const handleSave = async (experience) => {
    try {
      setSaveIsLoading(true);
      const importFromExperienceId =
        searchParams?.importFromExperienceId ||
        searchParams?.importFrom ||
        searchParams?.fromExperienceId;

      const payload = importFromExperienceId
        ? {
            ...experience,
            importFromExperienceId: String(importFromExperienceId),
          }
        : experience;
      const cancelConditions = experience.cancelConditions;

      const exp = await post(
        `/experiences`,
        omit(payload, ['cancelConditions']),
      );

      const experienceId = exp?.data?.id;
      if (experienceId && cancelConditions) {
        await saveExperienceCancelConditions({
          experienceId,
          payload: formatCancellationPoliciesToPayload(cancelConditions),
        });
      }

      notify(t('createSuccess'));
      setSaveIsLoading(false);
      return experienceId;
    } catch (err) {
      setSaveIsLoading(false);
      if (err?.response?.data?.message) {
        notify(err?.response?.data?.message, { type: 'error' });
      } else {
        notifyError(err);
      }
    }
  };

  return (
    <ExperienceLayout>
      <div className="relative">
        {saveIsLoading && (
          <div className="bg-gray-100/75 backdrop-blur-sm rounded-lg border z-20 absolute h-full w-full flex justify-center items-center">
            <Loader />
          </div>
        )}
        <ExperienceForm handleSave={handleSave} currentLocale={initialLocale} />
      </div>
    </ExperienceLayout>
  );
}
